var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRemove(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.79208 10.5423C5.6425 10.5423 5.51479 10.4908 5.40896 10.3877C5.30299 10.2847 5.25 10.157 5.25 10.0048C5.25 9.85246 5.30194 9.72343 5.40583 9.61773C5.50958 9.5119 5.63819 9.45898 5.79167 9.45898H14.2079C14.3575 9.45898 14.4852 9.51051 14.591 9.61357C14.697 9.71662 14.75 9.84426 14.75 9.99648C14.75 10.1488 14.6981 10.2779 14.5942 10.3836C14.4904 10.4894 14.3618 10.5423 14.2083 10.5423H5.79208Z",
    fill: "#101014"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemove);
export default __webpack_public_path__ + "static/media/remove.85141a1c6e5f7130dc01ed441d8cbe17.svg";
export { ForwardRef as ReactComponent };